// ===========================
// OZZ WEBSITE - MAIN JS
// ===========================

document.addEventListener('DOMContentLoaded', function () {

  // ===========================
  // HEADER SCROLL EFFECT
  // ===========================
//   const header = document.querySelector('.header');
//   if (header) {
//     window.addEventListener('scroll', () => {
//       if (window.scrollY > 40) {
//         header.classList.add('scrolled');
//       } else {
//         header.classList.remove('scrolled');
//       }
//     });
//   }

  // ===========================
  // MOBILE MENU
  // ===========================
//   const hamburger = document.querySelector('.hamburger');
//   const mobileMenu = document.querySelector('.mobile-menu');
//   const mobileOverlay = document.querySelector('.mobile-overlay');
//   const mobileClose = document.querySelector('.mobile-menu-close');

//   function openMenu() {
//     if (mobileMenu) mobileMenu.classList.add('open');
//     if (mobileOverlay) mobileOverlay.classList.add('open');
//     document.body.style.overflow = 'hidden';
//   }
//   function closeMenu() {
//     if (mobileMenu) mobileMenu.classList.remove('open');
//     if (mobileOverlay) mobileOverlay.classList.remove('open');
//     document.body.style.overflow = '';
//   }

//   if (hamburger) hamburger.addEventListener('click', openMenu);
//   if (mobileClose) mobileClose.addEventListener('click', closeMenu);
//   if (mobileOverlay) mobileOverlay.addEventListener('click', closeMenu);

  // ===========================
  // FAQ ACCORDION
  // ===========================
  document.querySelectorAll('.faq-question').forEach(btn => {
    
    btn.addEventListener('click', function () {
      console.log('clicked')
      const item = this.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      // Close all
      document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
      // Open this one if it was closed
      if (!isOpen) item.classList.add('open');
    });
  });

  // ===========================
  // STICKY CTA
  // ===========================
  // const stickyCta = document.querySelector('.sticky-cta');
  // if (stickyCta) {
  //   window.addEventListener('scroll', () => {
  //     if (window.scrollY > 600) {
  //       stickyCta.classList.add('visible');
  //     } else {
  //       stickyCta.classList.remove('visible');
  //     }
  //   });
  // }

  // ===========================
  // COUNTDOWN TIMER
  // ===========================
  // function startCountdown() {
  //   const countdowns = document.querySelectorAll('[data-countdown]');
  //   if (!countdowns.length) return;

  //   // Set end time: 7 days from now (stored in localStorage)
  //   let endTime = Number(localStorage.getItem('ozzCountdownEnd'));
  //   console.log(endTime)
  //   if (!endTime) {
  //     endTime = Date.now() + 7 * 24 * 60 * 60 * 1000;
  //     localStorage.setItem('ozzCountdownEnd', endTime);
  //   }
  //   endTime = parseInt(endTime);

  //   function update() {
  //     const now = Date.now();
  //     const diff = endTime - now;
  //     if (diff <= 0) {
  //       countdowns.forEach(el => {
  //         el.querySelector('[data-days]').textContent = '00';
  //         el.querySelector('[data-hours]').textContent = '00';
  //         el.querySelector('[data-minutes]').textContent = '00';
  //         el.querySelector('[data-seconds]').textContent = '00';
  //       });
  //       return;
  //     }
  //     const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  //     const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  //     const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  //     const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  //     countdowns.forEach(el => {
  //       const d = el.querySelector('[data-days]');
  //       const h = el.querySelector('[data-hours]');
  //       const m = el.querySelector('[data-minutes]');
  //       const s = el.querySelector('[data-seconds]');
  //       if (d) d.textContent = String(days).padStart(2, '0');
  //       if (h) h.textContent = String(hours).padStart(2, '0');
  //       if (m) m.textContent = String(minutes).padStart(2, '0');
  //       if (s) s.textContent = String(seconds).padStart(2, '0');
  //     });
  //   }
  //   update();
  //   setInterval(update, 1000);
  // }
  // startCountdown();

  // ===========================
  // SHOP FILTERS
  // ===========================
  // const filterBtns = document.querySelectorAll('.filter-btn');
  // const productCards = document.querySelectorAll('.product-card[data-category]');

  // filterBtns.forEach(btn => {
  //   btn.addEventListener('click', function () {
  //     filterBtns.forEach(b => b.classList.remove('active'));
  //     this.classList.add('active');
  //     const filter = this.dataset.filter;
  //     productCards.forEach(card => {
  //       if (filter === 'all' || card.dataset.category === filter) {
  //         card.style.display = '';
  //       } else {
  //         card.style.display = 'none';
  //       }
  //     });
  //   });
  // });

  // ===========================
  // CONTACT FORM SUBMIT
  // ===========================
  // const contactForm = document.querySelector('#contact-form');
  // if (contactForm) {
  //   contactForm.addEventListener('submit', function (e) {
  //     e.preventDefault();
  //     const btn = this.querySelector('[type="submit"]');
  //     btn.textContent = 'Message Sent! ✓';
  //     btn.style.background = 'var(--green)';
  //     btn.style.color = '#fff';
  //     btn.disabled = true;
  //     setTimeout(() => {
  //       btn.textContent = 'Send Message';
  //       btn.style.background = '';
  //       btn.style.color = '';
  //       btn.disabled = false;
  //       this.reset();
  //     }, 3000);
  //   });
  // }

  // ===========================
  // B2B FORM SUBMIT
  // ===========================
  // const b2bForm = document.querySelector('#b2b-form');
  // if (b2bForm) {
  //   b2bForm.addEventListener('submit', function (e) {
  //     e.preventDefault();
  //     const btn = this.querySelector('[type="submit"]');
  //     btn.textContent = 'Request Submitted! ✓';
  //     btn.style.background = 'var(--green)';
  //     btn.style.color = '#fff';
  //     btn.disabled = true;
  //   });
  // }

  // ===========================
  // SMOOTH SCROLL FOR ANCHOR LINKS
  // ===========================
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        closeMenu();
      }
    });
  });

  // ===========================
  // ACTIVE NAV LINK
  // ===========================
  // const currentPage = window.location.pathname.split('/').pop() || 'index.html';
  // document.querySelectorAll('.nav-link, .mobile-nav-link').forEach(link => {
  //   const href = link.getAttribute('href');
  //   if (href && href === currentPage) {
  //     link.classList.add('active');
  //   }
  // });

  // ===========================
  // INTERSECTION OBSERVER - FADE IN
  // ===========================
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.feature-card, .step-card, .testimonial-card, .product-card, .stat-card, .blog-card, .value-card').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    observer.observe(el);
  });

  // ===========================
  // ADD TO CART BUTTON
  // ===========================
  // document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
  //   btn.addEventListener('click', function () {
  //     const original = this.textContent;
  //     this.textContent = 'Added to Cart ✓';
  //     this.style.background = 'var(--green)';
  //     this.style.color = '#fff';
  //     setTimeout(() => {
  //       this.textContent = original;
  //       this.style.background = '';
  //       this.style.color = '';
  //     }, 2000);
  //   });
  // });

});
